import { useRef } from "react";

export const useSingleAndDoubleClick = (onClick, onDoubleClick, delay = 200) => {
  const clickTimer = useRef(null);

  const handler = (e, ...args) => {
    e.stopPropagation();
    if (clickTimer.current) {
      clearTimeout(clickTimer.current);
      clickTimer.current = null;
      onDoubleClick(e, ...args);
    } else {
      clickTimer.current = setTimeout(() => {
        onClick(e, ...args);
        clickTimer.current = null;
      }, delay);
    }
  };

  return handler;
};

export default useSingleAndDoubleClick;
